/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCompanyRoleSettings200ResponsePermissionsInner } from './GetCompanyRoleSettings200ResponsePermissionsInner';
import {
    GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON,
    GetCompanyRoleSettings200ResponsePermissionsInnerFromJSONTyped,
    GetCompanyRoleSettings200ResponsePermissionsInnerToJSON,
} from './GetCompanyRoleSettings200ResponsePermissionsInner';

/**
 * 
 * @export
 * @interface UpdateCompanyRoleRequest
 */
export interface UpdateCompanyRoleRequest {
    /**
     * `権限名`
     * @type {string}
     * @memberof UpdateCompanyRoleRequest
     */
    roleName: string;
    /**
     * `許可設定`
     * @type {Array<GetCompanyRoleSettings200ResponsePermissionsInner>}
     * @memberof UpdateCompanyRoleRequest
     */
    permissions?: Array<GetCompanyRoleSettings200ResponsePermissionsInner>;
}

/**
 * Check if a given object implements the UpdateCompanyRoleRequest interface.
 */
export function instanceOfUpdateCompanyRoleRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "roleName" in value;

    return isInstance;
}

export function UpdateCompanyRoleRequestFromJSON(json: any): UpdateCompanyRoleRequest {
    return UpdateCompanyRoleRequestFromJSONTyped(json, false);
}

export function UpdateCompanyRoleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCompanyRoleRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roleName': json['role_name'],
        'permissions': !exists(json, 'permissions') ? undefined : ((json['permissions'] as Array<any>).map(GetCompanyRoleSettings200ResponsePermissionsInnerFromJSON)),
    };
}

export function UpdateCompanyRoleRequestToJSON(value?: UpdateCompanyRoleRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role_name': value.roleName,
        'permissions': value.permissions === undefined ? undefined : ((value.permissions as Array<any>).map(GetCompanyRoleSettings200ResponsePermissionsInnerToJSON)),
    };
}

